import TextField, { type TextFieldProps } from '@mui/material/TextField'
import React from 'react'
import { Controller, type FieldValues, type Path, type UseFormReturn, get } from 'react-hook-form'

import ErrorField from './ErrorField'

function parse (value: string): '' | number | null {
  if (value.trim() === '') return null
  const intValue = Number.parseInt(value, 10)
  return Number.isNaN(intValue) ? null : intValue
}

interface IntegerFieldProps<TFieldValues extends FieldValues> {
  /** An empty string makes the input initially empty. Remember to handle the empty string if one is used. */
  form: Pick<UseFormReturn<TFieldValues>, 'control' | 'formState'>
  name: Path<TFieldValues>
  style?: TextFieldProps['style']
  title: string
}

export default function IntegerField<T extends FieldValues> (props: IntegerFieldProps<T>): JSX.Element {
  const error = get(props.form.formState.errors, props.name)
  return (
    <>
      <Controller
        control={props.form.control}
        name={props.name}
        render={({ field: { onBlur, onChange, value } }) => (
          <TextField
            error={error != null}
            label={props.title}
            onBlur={onBlur}
            onChange={(ev) => onChange(parse(ev.target.value))}
            // Prevent triggering increment/decrement value on mouse wheel scroll
            onWheel={event => event.currentTarget.querySelector('input')?.blur()}
            style={props.style}
            type='number'
            value={value}
          />
        )}
      />

      <ErrorField message={error?.message} />
    </>
  )
}
